module.exports = __webpack_public_path__ + "img/Frente-50-02 open.62ed74b5.jpg";